const gradeColors = {
  BIEN_DARK: '#7DA900',
  BIEN_LIGHT: '#F4FFB4',
  EXCELENTE_DARK: '#459D24',
  EXCELENTE_LIGHT: '#C0FFCE',
  INSUFICIENTE_DARK: '#FF0000',
  INSUFICIENTE_LIGHT: '#FFC0C0',
  NOTABLE_DARK: '#54A900',
  NOTABLE_LIGHT: '#E0FFC0',
  SUFICIENTE_DARK: '#A89700',
  SUFICIENTE_LIGHT: '#FFF9C0',
}

export default gradeColors
